import { render, staticRenderFns } from "./MenuListGroup.vue?vue&type=template&id=2acaa9b6&scoped=true&"
import script from "./MenuListGroup.vue?vue&type=script&lang=js&"
export * from "./MenuListGroup.vue?vue&type=script&lang=js&"
import style0 from "./MenuListGroup.vue?vue&type=style&index=0&id=2acaa9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acaa9b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VIcon,VListItem,VListItemContent,VListItemGroup,VListItemIcon,VListItemTitle,VSubheader})
